import { RefObject, useEffect } from 'react';

/**
 * A custom hook that uses the ResizeObserver API to call a function
 * whenever the size of a referenced element changes.
 *
 * @param ref A React ref object pointing to the HTML element to observe.
 * @param callback The function to execute when a resize is detected.
 * @param options - ResizeObserver options
 */
const useResizeObserver = (ref: RefObject<HTMLElement>, callback: ResizeObserverCallback): void => {
  useEffect(() => {
    const observer = new ResizeObserver(callback);

    const target = ref.current;

    if (target) {
      observer.observe(target);
    }

    // Cleanup function to disconnect the observer
    return () => {
      if (target) {
        observer.unobserve(target);
      }
      observer.disconnect();
    };
  }, [ref, callback]);
};

export default useResizeObserver;
